.container {
  display: grid;
  gap: 8px;
}
